import i18n from '../i18n/fr.js';

const t = i18n[window.locale].validations;


//------------------------------------------------------------------------------
//  COMMON VALIDATIONS
//------------------------------------------------------------------------------

export const commonValidations = {
  is_not_empty: {
    errorMsg: t.cant_be_blank,
    validate: value => {
      return !(value === "" || value === undefined || value === null);
    },
  },
  is_not_empty_zero_for_no_needs: {
    errorMsg: t.cant_be_blank_zero_for_no_needs,
    validate: value => {
      return !(value === "" || value === undefined || value === null);
    },
  },
  is_numeric: {
    errorMsg: t.not_numeric,
    validate: value => {
      return (!isNaN(parseFloat(value)) && isFinite(value));
    },
  },
  is_a_positive_number: {
    errorMsg: t.not_a_positive_number,
    validate: value => {
      return (value >= 0);
    },
  },
  is_greater_than_zero: {
    errorMsg: t.not_greater_than_zero,
    validate: value => {
      return (value > 0);
    },
  },
  has_an_option_selected: {
    errorMsg: t.no_option_selected,
    validate: value => {
      return !(value === "" || value === undefined || value === null);
    },
  },
};


//------------------------------------------------------------------------------
//  FIELDS VALIDATIONS
//------------------------------------------------------------------------------

export const fieldsValidations = {
  living_area: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
    specificValidation: {
      errorMsg: t.living_area.overflow,
      validate: value => {
        return (value >= 0 && value <= 10000);
      },
    },
  },
  inhabitants: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
    specificValidation: {
      errorMsg: t.inhabitants.overflow,
      validate: value => {
        return (value >= 1 && value <= 200);
      },
    },
  },
  invoices: {
    required: true,
    beforeValidations: ['is_not_empty'],
    specificValidation: {
      errorMsg: t.invoices.all_invoices_must_be_numeric,
      validate: value => {
        let hasError = false;
        value.trim().split(/\s/).every( invoiceAmount => {
          if (!isNaN(parseFloat(invoiceAmount)) && isFinite(invoiceAmount)) {
            return true;
          } else {
            hasError = true;
            return false;
          }
        });
        return !hasError;
      },
    },
  },
  building_years: {
    required: true,
    beforeValidations: ['has_an_option_selected'],
  },
  consumption: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
  },
  current_heating_system: {
    required: true,
    beforeValidations: ['has_an_option_selected'],
  },
  current_hot_water_system: {
    required: true,
    beforeValidations: ['has_an_option_selected'],
  },
  heating_needs: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_greater_than_zero'],
  },
  hot_water_needs: {
    required: true,
    beforeValidations: ['is_not_empty_zero_for_no_needs', 'is_numeric', 'is_a_positive_number'],
  },
  considered_heating_system: {
    required: true,
    beforeValidations: ['has_an_option_selected'],
  },
  considered_hot_water_system: {
    required: true,
    beforeValidations: ['has_an_option_selected'],
  },
  solar_panel_surface: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_greater_than_zero'],
    specificValidation: {
      errorMsg: t.solar_panel_surface.min,
      validate: value => {
        return (value > 0);
      },
    },
  },
  solar_estimated_investment: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
  },
  heating_estimated_investment: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
  },
  hot_water_estimated_investment: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
  },
  heating_efficiency: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_greater_than_zero'],
    specificValidation: {
      errorMsg: t.heating_efficiency.overflow,
      validate: value => {
        return (value >= 0 && value <= 1000);
      },
    },
  },
  hot_water_efficiency: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
    specificValidation: {
      errorMsg: t.hot_water_efficiency.overflow,
      validate: value => {
        return (value >= 0 && value <= 1000);
      },
    },
  },
  heating_energy_price: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_greater_than_zero'],
    specificValidation: {
      errorMsg: t.heating_energy_price.overflow,
      validate: value => {
        return (value >= 0 && value <= 100);
      },
    },
  },
  hot_water_energy_price: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_greater_than_zero'],
    specificValidation: {
      errorMsg: t.hot_water_energy_price.overflow,
      validate: value => {
        return (value >= 0 && value <= 100);
      },
    },
  },
  heating_energy_price_variation: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric'],
  },
  hot_water_energy_price_variation: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric'],
  },
  heating_maintenance: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
  },
  hot_water_maintenance: {
    required: true,
    beforeValidations: ['is_not_empty', 'is_numeric', 'is_a_positive_number'],
  },
};



// WEBPACK FOOTER //
// ./assets/javascripts/datas/_validation_rules.js